import { client } from '@utils';

const BASE = 'reservations';

const getServicePeriods = () => client.authorized.get(`${BASE}/service-periods`);
const createServicePeriod = data => client.authorized.post(`${BASE}/service-periods`, data);
const updateServicePeriod = data => client.authorized.put(`${BASE}/service-periods`, data);
const deleteServicePeriod = data => client.authorized.delete(`${BASE}/service-periods`, { data });

const getGuests = (q) => client.authorized.get(`${BASE}/guests`, { params: q ? { q } : undefined });
const createGuest = data => client.authorized.post(`${BASE}/guests`, data);
const updateGuest = data => client.authorized.put(`${BASE}/guests`, data);

const getReservations = (date) => client.authorized.get(BASE, { params: { date } });
const getReservationsRange = (start, end) => client.authorized.get(BASE, { params: { start, end } });
const createReservation = data => client.authorized.post(BASE, data);
const updateReservation = data => client.authorized.put(BASE, data);
const cancelReservation = data => client.authorized.delete(BASE, { data });

const getAvailability = (date, party_size) =>
  client.authorized.get(`${BASE}/availability`, { params: { date, party_size } });

const getWaitlist = (date) => client.authorized.get(`${BASE}/waitlist`, { params: { date } });
const addToWaitlist = data => client.authorized.post(`${BASE}/waitlist`, data);
const updateWaitlist = data => client.authorized.put(`${BASE}/waitlist`, data);

const getVenueSections = () => client.authorized.get(`${BASE}/venue-sections`);
const createVenueSection = data => client.authorized.post(`${BASE}/venue-sections`, data);
const updateVenueSection = data => client.authorized.put(`${BASE}/venue-sections`, data);
const deleteVenueSection = data => client.authorized.delete(`${BASE}/venue-sections`, { data });

export default {
  getVenueSections,
  createVenueSection,
  updateVenueSection,
  deleteVenueSection,
  getServicePeriods,
  createServicePeriod,
  updateServicePeriod,
  deleteServicePeriod,
  getGuests,
  createGuest,
  updateGuest,
  getReservations,
  getReservationsRange,
  createReservation,
  updateReservation,
  cancelReservation,
  getAvailability,
  getWaitlist,
  addToWaitlist,
  updateWaitlist,
};
